import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { RouteComponentProps } from 'react-router-dom'

// components
import { BodyHead, BodyTitle } from '../../components/bakery/styleds'
// import Mint from '../BakeryArtworks/components/Mint'
import Mint from '../BakeryArtworks/components/NewMint'
// constants
import { mintInfo, mintType } from '../../constants/artwork'
import { userMintMarketType } from '../../userType/userMintMarketType'

export default function MintArtworks({match: {params: { nftType }}}:RouteComponentProps<{ nftType: string}>) {
  const theme = useContext(ThemeContext)
  let marketType = userMintMarketType(nftType)

  return (
    <>
      <BodyHead>
        <BodyTitle fontSize={32} fontFamily="Roboto-Bold" marginTop={0} color={theme.bsText28}>
          { mintType.title[marketType] }
        </BodyTitle>
      </BodyHead>
      <Mint info={mintInfo} type={marketType}></Mint>
     </>
  )
}
